/**
 * Image orientation is now handled entirely by the backend
 * (App\Helpers\ImageOrientationHelper). This function exists only to keep
 * the existing call sites working — it returns the file unchanged.
 */
export async function fixImageOrientation(file: File): Promise<File> {
  return file;
}

